import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import GetAppIcon from '@material-ui/icons/GetApp';
import DocumentActionButton
	from '@components/CaseDetails/DocumentInformationDisplay/DocumentDetails/DocumentActions/DocumentActionButton';
import {
	useDocumentDetailsContext
} from '@components/CaseDetails/DocumentInformationDisplay/DocumentDetails/DocumentDetails';
import useGetDocument from '@data/document/hooks/useGetDocument/useGetDocument';
import { UserProfileDocViewPermissionSelector } from '@store/selectors/UserProfileSelector';
import DownloadDocumentProps
	from '@components/CaseDetails/DocumentInformationDisplay/DocumentDetails/DocumentActions/DownloadDocumentProps';
import { useSsmUiFlags } from '@utilities/hooks/useSsmUiFlags/useSsmUiFlags';
import { useGetSignedUrlAndGetDoc } from '@data/document/hooks/useGetSignedUrlAndGetDoc/useGetSignedUrlAndGetDoc';

const useStyles = makeStyles({
	displayNone: {
		display: 'none',
	},
});
const DownloadDocument: React.FC<DownloadDocumentProps> = ({ fieldName = 'action-download' }) => {
	const classes = useStyles();
	const { id, file: fileName } = useDocumentDetailsContext();
	const anchorRef = React.useRef<HTMLAnchorElement | null>(null);
	const getSignedUrlAndGetDoc = useGetSignedUrlAndGetDoc();
	const { ssmuiSignedUrl } = useSsmUiFlags();
	const hasDownloadPermission = useSelector(UserProfileDocViewPermissionSelector);
	const getDoc = useGetDocument();

	const handleClick = React.useCallback(() => {
		const onSuccess = (doc: Blob) => {
			if (!anchorRef.current) { return; }
			const url = window.URL.createObjectURL(doc);
			anchorRef.current.href = url;
			anchorRef.current.click();

			window.URL.revokeObjectURL(url);
		};

		if (ssmuiSignedUrl) {
			getSignedUrlAndGetDoc(id, onSuccess);
		} else {
			getDoc(id, onSuccess);
		}
	}, [getDoc, getSignedUrlAndGetDoc, id, ssmuiSignedUrl]);

	if (!hasDownloadPermission) { return null; }

	return <>
		<a ref={anchorRef} download={fileName} className={classes.displayNone} />
		<DocumentActionButton fieldName={fieldName} onClick={handleClick}><GetAppIcon />Download</DocumentActionButton>
	</>;
};

export default DownloadDocument;
